import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { fetchConnection } from '@/services/fetchConnection';
import { usePracticeStore } from '@/store/usePracticeStore';

export const useConnection = () => {
  const { connection, setConnection } = usePracticeStore();
  const navigate = useNavigate();

  const { isFetching, data, error } = useQuery({
    queryKey: ['connection'],
    queryFn: fetchConnection,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (data?.connection) {
      setConnection(data.connection);
    }
  }, [data, setConnection]);

  useEffect(() => {
    if (data?.error) {
      // Check for the specific location error and redirect to 404
      if (
        data.error === 'Missing or invalid location, please provide a valid ID in the URL' ||
        data.error === 'Location not found, please check the URL or contact support'
      ) {
        navigate('/404');
        return;
      }
      toast.error(data?.error);
    }
  }, [data?.error, navigate]);

  useEffect(() => {
    if (error) {
      toast.error(error.message);
    }
  }, [error]);

  return {
    isFetching,
    connection,
  };
};
